/* HB 2026-10-12 (round 31, audit item 8): the header's two scripts, moved out of sections/header.liquid (7 KB that
   every page and every header refresh carried inline): the header-swatch element (SHOP COLOR) and the sort that puts
   the pieces of the last chosen color tag first. The same code; the two Liquid values it used come from
   window.HBHeaderSwatchConfig, printed by the header. */
const HB_HS = window.HBHeaderSwatchConfig || { collectionTemplate: false, collectionHandle: '' };

    class HeaderSwatch extends HTMLElement {
      constructor() {
        super();
        this.link = this.querySelector('.shop_by_color_link');
        this.colors = this.querySelectorAll('.mega-menu__list_color li');
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
      this.connectEvents();

      

        this.querySelector('.colors_swatch_menu').addEventListener('click', () => {
          const drawer = document.querySelector('header-drawer');
          if (drawer && drawer.isOpen) {
            drawer.close(); // FULL cleanup
            const summary = drawer.querySelector('summary');
            const details = drawer.querySelector('details');
            if (!summary) return;
            summary.setAttribute('aria-expanded', 'false');
            details.classList.remove('menu-open');
            details.removeAttribute('open');
          }
          this.classList.toggle('is-active');
        });


      

      const menu = document.querySelector('.color_mega_menu_desktop');
      function openMenu() {
        menu.style.maxHeight = menu.scrollHeight + "px";
      }

      function closeMenu() {
        menu.style.maxHeight = "0px";
      }
      
      window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        // 👇 calculate every time (important for mobile)
        const topThreshold = document.documentElement.scrollHeight * 0.15;

        const hasChecked = [...this.colors].some((el) =>
          el.classList.contains('is-checked')
        );

        if (currentScroll <= topThreshold) {
          // 👉 Within top 10% → SHOW
          if (HB_HS.collectionTemplate) {
            this.classList.add('is-active');
          }
          
        } else {
          // 👉 Outside 10% → HIDE
          this.classList.remove('is-active');
          
        }
      });
      

  document.addEventListener('click', (e) => {
    if (!this.contains(e.target)) this.classList.remove('is-active');
  });

  this.setDefaultChecked();
}

     setDefaultChecked() {
          const params = new URLSearchParams(window.location.search);

          const selectedTags = params
            .getAll('filter.p.tag')
            .map((t) => t.toLowerCase().trim());

          let count = 0;

          this.colors.forEach((color) => {
            const input = color.querySelector('input');
            if (!input) return;

            const val = input.value.toLowerCase().trim();
            const isMatch = selectedTags.includes(val);

            if (isMatch) {
          setInterval(() => {
              
            color.setAttribute('class', 'is-checked');
          const count =
              document
                .querySelector('.color_mega_menu_desktop .mega-menu__list_color')
                ?.querySelectorAll('li.is-checked').length || 0;
            const colorFilter = document.querySelector('.color-swatch-count');
            if (colorFilter) {
              colorFilter.style.display = count > 0 ? 'flex' : 'none';
              colorFilter.innerText = count;
            } 
          }, 100);
        }
          });

          // ✅ Move count logic outside loop
          const colorFilter = document.querySelector('.color-swatch-count');
          if (colorFilter) {
            colorFilter.style.display = count > 0 ? 'flex' : 'none';
            colorFilter.innerText = count;
          }
        }

      disconnectedCallback() {
        this.disconnectEvents();
      }

      connectEvents() {
        this.colors.forEach((color) => {
          color.addEventListener('click', this.handleClick);
        });
      }

      disconnectEvents() {
        this.colors.forEach((color) => {
          color.removeEventListener('click', this.handleClick);
        });
      }

      handleClick(e) {
        e.preventDefault();

        const drawer = document.querySelector('header-drawer');
        if (drawer && drawer.isOpen) {
          drawer.close();
        }

        const colorElement = e.currentTarget;
        this.updateHREF(colorElement);
      }

      updateHREF(colorElement) {
        const input = colorElement.querySelector('input');
        if (!input) return;

        const tag = input.value.trim();
        if (!tag) return;

        const currentUrl = new URL(window.location.href);
        const currentParams = currentUrl.searchParams;

        let existing = [];

        if (currentUrl.pathname.includes('/collections/')) {
          existing = currentParams.getAll('filter.p.tag');
        }

        if (existing.includes(tag)) {
          existing = existing.filter((t) => t !== tag);
        } else {
          existing.push(tag);
        }

        const collection_handle = HB_HS.collectionTemplate
          ? '/collections/' + (HB_HS.collectionHandle || '')
          : '/collections/all';

        const redirectUrl = new URL(collection_handle, window.location.origin);
        const redirectParams = redirectUrl.searchParams;

        existing.forEach((t) => redirectParams.append('filter.p.tag', t));

        colorElement.classList.toggle('is-checked');

        window.location.href = redirectUrl.toString();
      }
    }

    if (!customElements.get('header-swatch')) {
      customElements.define('header-swatch', HeaderSwatch);
    }

  /* ==============================
    SORT PRODUCTS BY LAST TAG
  ============================== */
  (function () {

  function getTagsFromURL() {
    const params = new URLSearchParams(window.location.search);

    let tags = params.getAll("filter.p.tag").map(tag =>
      decodeURIComponent(tag).replace(/\+/g, " ").toLowerCase().trim()
    );

    if (!tags.length) return [];

    // Last selected = highest priority
    return tags.reverse();
  }

  function reorderProducts() {
    const tags = getTagsFromURL();
    if (!tags.length) return;

    const products = Array.from(document.querySelectorAll(".product-grid__item"));
    const container = products[0]?.parentNode;

    if (!container || !products.length) return;

    const getPriority = (product) => {
      const productTags = (product.dataset.tags || "")
        .toLowerCase()
        .split(",")
        .map(tag => tag.trim());

      let bestIndex = tags.length;

      tags.forEach((tag, index) => {
        if (productTags.includes(tag)) {
          bestIndex = Math.min(bestIndex, index);
        }
      });

      return bestIndex;
    };

    products.sort((a, b) => getPriority(a) - getPriority(b));

    products.forEach(product => container.appendChild(product));
  }

  // Wait until products are actually rendered
  function waitForProductsAndReorder() {
    let attempts = 0;

    const interval = setInterval(() => {
      const products = document.querySelectorAll(".product-grid__item");

      if (products.length > 0) {
        clearInterval(interval);
        reorderProducts();
      }

      // stop after ~3 seconds
      if (attempts++ > 30) clearInterval(interval);

    }, 100);
  }

  // Run on initial page load
  document.addEventListener("DOMContentLoaded", waitForProductsAndReorder);

  // Run after Shopify filter / pagination updates
  document.addEventListener("shopify:section:load", waitForProductsAndReorder);
  document.addEventListener("shopify:section:reorder", waitForProductsAndReorder);

  // 🔥 Bulletproof: Observe DOM changes (AJAX / pagination / filters)
  const grid = document.querySelector("#ProductGridContainer");

  if (grid) {
    const observer = new MutationObserver(() => {
      waitForProductsAndReorder();
    });

    observer.observe(grid, {
      childList: true,
      subtree: true
    });
  }

})();
